import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';
import { FAQS, BRAND_INFO } from '../data/mock';

const FAQPage = () => {
  usePageTitle(
    `FAQ | ${BRAND_INFO.name}`,
    'Common questions about ordering bloodwork, getting drawn, uploading PDFs, results timing, refunds, and account management on Anabolic Surge.'
  );

  return (
    <>
      <Header />

      <section className="pt-28 lg:pt-36 pb-12 bg-cream-100">
        <div className="container-wide">
          <p className="eyebrow">FAQ</p>
          <h1 className="mt-5 font-display text-display-lg text-ink-900 max-w-3xl">
            Frequently asked questions.
          </h1>
          <p className="mt-5 text-lg text-ink-600 max-w-2xl">
            Quick answers to the things people ask most before they place their first panel.
            If yours isn&apos;t here, drop us a line at{' '}
            <Link to="/contact" className="text-brick-500 hover:underline">contact us</Link>.
          </p>
        </div>
      </section>

      <section className="pb-24 bg-cream-100">
        <div className="container-tight space-y-3">
          {FAQS.map((f, i) => (
            <details
              key={i}
              className="group bg-cream-50 border border-cream-200 rounded-3xl p-6 open:border-brick-300 transition-all"
            >
              <summary className="flex items-start justify-between gap-6 cursor-pointer list-none">
                <span className="font-display text-lg text-ink-900">{f.q}</span>
                <span className="shrink-0 mt-1 inline-flex items-center justify-center w-8 h-8 rounded-full bg-cream-100 text-ink-600 group-open:bg-brick-500 group-open:text-white transition-colors">
                  <ChevronRight className="w-4 h-4 transition-transform group-open:rotate-90" />
                </span>
              </summary>
              <p className="mt-4 text-ink-700 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default FAQPage;
